import React from "react";
import * as Icons from "react-icons/tb";

// navigation
export const menu = [{
    name: "Dashboard",
    url: "/",
    icon: <Icons.TbLayout className="menu_icon" />,
  },
  {
    name: "event management",
    icon: <Icons.TbCalendarCog className="menu_icon" />,
    url: "/event-managment",
    subMenu: [{
        name: "Categories",
        url: "/categories/manage",
        icon: <Icons.TbCategory className="menu_icon" />,
      },
      {
        name: "Event",
        url: "/events/manage",
        icon: <Icons.TbTimelineEvent className="menu_icon" />,
      },
      {
        name: "Calendar",
        url: "/events/calendar",
        icon: <Icons.TbCalendar className="menu_icon" />,
      },
    ],
  },

  {
    name: "Organizers",
    url: "/organizers/manage",
    icon: <Icons.TbUser className="menu_icon" />,
  },
  {
    name: "Reviews",
    url: "/reviews",
    icon: <Icons.TbStar className="menu_icon" />,
  },
  {
    name: "Users",
    url: "/users/list",
    icon: <Icons.TbUser className="menu_icon" />,
  },
  // {
  //   name: "Venue",
  //   url: "/venue",
  //   subMenu: [{
  //       name: "Add Venue",
  //       url: "/add",
  //       icon: <Icons.TbPlus />,
  //     },
  //     {
  //       name: "Manage Venue",
  //       url: "/manage",
  //       icon: <Icons.TbList />,
  //     },
  //   ],
  //   icon: <Icons.TbCurrentLocation className="menu_icon" />,
  // },
  {
    name: "pages",
    url: "/pages",
    icon: <Icons.TbPlug className="menu_icon" />,
  },

  {
    name: "Payment",
    url: "/payment",
    icon: <Icons.TbCreditCard className="menu_icon" />,
    subMenu: [{
        name: "Transactions",
        url: "/transactions",
        icon: <Icons.TbCurrencyDollar className="menu_icon" />,
      },
      {
        name: "Payment Methods",
        url: "/payment-method",
        icon: <Icons.TbDeviceMobileDollar className="menu_icon" />,
      },
    ],
  },
  {
    name: "Setting",
    url: "/setting",
    icon: <Icons.TbSettings className="menu_icon" />,
    subMenu: [{
        name: "General",
        url: "/general",
        icon: <Icons.TbSettings className="menu_icon" />,
      },
      {
        name: "Email",
        url: "/email",
        icon: <Icons.TbMail className="menu_icon" />,
      },
      {
        name: "Languages",
        url: "/languages",
        icon: <Icons.TbLanguage className="menu_icon" />,
      },
      {
        name: "Permalink",
        url: "/permalink",
        icon: <Icons.TbLink className="menu_icon" />,
      },
      {
        name: "Social Login",
        url: "/social-login",
        icon: <Icons.TbLogin className="menu_icon" />,
      },
      {
        name: "Cronjob",
        url: "/cronjob",
        icon: <Icons.TbClock className="menu_icon" />,
      },
      {
        name: "API Settings",
        url: "/api",
        icon: <Icons.TbSettings className="menu_icon" />,
      },
    ],
  },
  {
    name: "Media",
    url: "/media",
    icon: <Icons.TbPhoto className="menu_icon" />,
  },
  {
    name: "Platform Administration",
    url: "/admin",
    icon: <Icons.TbShieldLock className="menu_icon" />,
    subMenu: [{
        name: "Roles and Permissions",
        url: "/admin/roles",
        icon: <Icons.TbUserShield className="menu_icon" />,
      },
      {
        name: "Users",
        url: "/admin/users",
        icon: <Icons.TbUsers className="menu_icon" />,
      },
    ],
  },
];

// Events Topics
export const eventTopics = [{
    value: "space-exploration-symposium",
    label: "Space Exploration Symposium",
  },
  { value: "charity-fundraising-gala", label: "Charity Fundraising Gala" },
];

export const events = [{
    id: 1,
    topic: "Music",
    name: "Music Festival 1",
    image: "https://picsum.photos/1000?seed=1",
    date: "2023-10-15",
    location: "Central Park",
    time: "18:00",
    status: "success",
    price: "$25",
    organizer: {
      name: "Music Vibes Inc.",
      email: "info@musicvibes.com",
      phone: "+1-123-456-7890",
      image: "https://picsum.photos/1000?seed=2",
    },
    participants: [{
        name: "John Smith",
        email: "john@example.com",
        phone: "+1-987-654-3210",
        image: "https://picsum.photos/1000?seed=3",
      },
      {
        name: "Jane Doe",
        email: "jane@example.com",
        phone: "+1-555-123-4567",
        image: "https://picsum.photos/1000?seed=4",
      },
    ],
    description: "Join us for a night of live music in Central Park!",
    videoUrl: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
    indoor: true,
    maxParticipants: 1000,
    duration: "3 hours",
    repetition: "N/A",
    ticket: {
      name: "General Admission",
      price: 25,
      currency: "USD",
      additionalInstructions: "No outside food or drinks allowed.",
    },
    ticketsOnSale: 500,
  },
  {
    id: 2,
    topic: "Comedy",
    name: "Comedy Night Live",
    image: "https://picsum.photos/1000?seed=5",
    date: "2023-11-20",
    location: "City Theater",
    time: "20:00",
    status: "Scheduled",
    price: "$20",
    organizer: {
      name: "LaughMasters",
      email: "info@laughmasters.com",
      phone: "+1-888-765-4321",
      image: "https://picsum.photos/1000?seed=6",
    },
    participants: [{
        name: "David Johnson",
        email: "david@example.com",
        phone: "+1-555-987-6543",
        image: "https://picsum.photos/1000?seed=7",
      },
      {
        name: "Emily Wilson",
        email: "emily@example.com",
        phone: "+1-777-321-6548",
        image: "https://picsum.photos/1000?seed=8",
      },
    ],
    description: "A night of laughter and comedy at City Theater!",
    videoUrl: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
    indoor: true,
    maxParticipants: 500,
    duration: "2.5 hours",
    repetition: "Weekly",
    ticket: {
      name: "Standard Ticket",
      price: 20,
      currency: "USD",
      additionalInstructions: "18+ only.",
    },
    ticketsOnSale: 300,
  },
  {
    id: 3,
    topic: "Sports",
    name: "Sports Day Out",
    image: "https://picsum.photos/1000?seed=9",
    date: "2023-09-25",
    location: "Sports Complex",
    time: "10:00",
    status: "Cancelled",
    price: "$10",
    organizer: {
      name: "SportsClub",
      email: "info@sportsclub.com",
      phone: "+1-333-999-8888",
      image: "https://picsum.photos/1000?seed=10",
    },
    participants: [{
        name: "Michael Brown",
        email: "michael@example.com",
        phone: "+1-555-111-2222",
        image: "https://picsum.photos/1000?seed=11",
      },
      {
        name: "Robert Wilson",
        email: "robert@example.com",
        phone: "+1-777-444-5555",
        image: "https://picsum.photos/1000?seed=12",
      },
    ],
    description: "A day of sports and fun at the Sports Complex!",
    videoUrl: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
    indoor: true,
    maxParticipants: 300,
    duration: "6 hours",
    repetition: "N/A",
    ticket: {
      name: "Sports Pass",
      price: 10,
      currency: "USD",
      additionalInstructions: "Bring your own sports equipment.",
    },
    ticketsOnSale: 100,
  },
  {
    id: 4,
    topic: "Art",
    name: "Art Exhibition",
    image: "https://picsum.photos/1000?seed=13",
    date: "2023-09-30",
    location: "Art Gallery",
    time: "15:00",
    status: "Postponed",
    price: "$15",
    organizer: {
      name: "Artistic Creations",
      email: "info@artcreations.com",
      phone: "+1-777-666-5555",
      image: "https://picsum.photos/1000?seed=14",
    },
    participants: [{
        name: "Alice Johnson",
        email: "alice@example.com",
        phone: "+1-999-888-7777",
        image: "https://picsum.photos/1000?seed=15",
      },
      {
        name: "Bob Smith",
        email: "bob@example.com",
        phone: "+1-333-222-1111",
        image: "https://picsum.photos/1000?seed=16",
      },
    ],
    description: "Explore the world of art at our gallery!",
    videoUrl: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
    indoor: true,
    maxParticipants: 200,
    duration: "4 hours",
    repetition: "N/A",
    ticket: {
      name: "Art Lover Pass",
      price: 15,
      currency: "USD",
      additionalInstructions: "No photography inside the gallery.",
    },
    ticketsOnSale: 150,
  },
  {
    id: 5,
    topic: "Food",
    name: "Food Festival",
    image: "https://picsum.photos/1000?seed=17",
    date: "2023-10-05",
    location: "Downtown Square",
    time: "12:00",
    status: "Completed",
    price: "$20",
    organizer: {
      name: "Foodie Delights",
      email: "info@foodiedelights.com",
      phone: "+1-888-999-7777",
      image: "https://picsum.photos/1000?seed=18",
    },
    participants: [{
        name: "Grace Wilson",
        email: "grace@example.com",
        phone: "+1-777-888-9999",
        image: "https://picsum.photos/1000?seed=19",
      },
      {
        name: "Sam Davis",
        email: "sam@example.com",
        phone: "+1-555-666-7777",
        image: "https://picsum.photos/1000?seed=20",
      },
    ],
    description: "A culinary journey awaits you at the Food Festival!",
    videoUrl: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4",
    indoor: false,
    maxParticipants: 800,
    duration: "5 hours",
    repetition: "N/A",
    ticket: {
      name: "Foodie Pass",
      price: 20,
      currency: "USD",
      additionalInstructions: "Try a variety of cuisines from local vendors.",
    },
    ticketsOnSale: 700,
  },
  {
    id: 6,
    topic: "Technology",
    name: "Tech Conference",
    image: "https://picsum.photos/1000?seed=21",
    date: "2023-11-10",
    location: "Tech Center",
    time: "09:30",
    status: "Ongoing",
    price: "$30",
    organizer: {
      name: "Tech Connect",
      email: "info@techconnect.com",
      phone: "+1-888-555-6666",
      image: "https://picsum.photos/1000?seed=22",
    },
    participants: [{
        name: "Sarah Johnson",
        email: "sarah@example.com",
        phone: "+1-555-777-8888",
        image: "https://picsum.photos/1000?seed=23",
      },
      {
        name: "Daniel Wilson",
        email: "daniel@example.com",
        phone: "+1-777-888-5555",
        image: "https://picsum.photos/1000?seed=24",
      },
    ],
    description: "Stay updated with the latest in technology at our conference!",
    videoUrl: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
    indoor: true,
    maxParticipants: 400,
    duration: "8 hours",
    repetition: "Daily",
    ticket: {
      name: "Tech Enthusiast Pass",
      price: 30,
      currency: "USD",
      additionalInstructions: "Bring your own devices for hands-on sessions.",
    },
    ticketsOnSale: 250,
  },
  {
    id: 7,
    topic: "Fashion",
    name: "Fashion Show",
    image: "https://picsum.photos/1000?seed=25",
    date: "2023-10-28",
    location: "Fashion Hall",
    time: "19:00",
    status: "Sold Out",
    price: "$50",
    organizer: {
      name: "Fashionistas Inc.",
      email: "info@fashionistas.com",
      phone: "+1-999-666-5555",
      image: "https://picsum.photos/1000?seed=26",
    },
    participants: [{
        name: "Linda Davis",
        email: "linda@example.com",
        phone: "+1-888-999-6666",
        image: "https://picsum.photos/1000?seed=27",
      },
      {
        name: "Tom Wilson",
        email: "tom@example.com",
        phone: "+1-666-555-8888",
        image: "https://picsum.photos/1000?seed=28",
      },
    ],
    description: "Experience the world of fashion like never before!",
    videoUrl: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4",
    indoor: true,
    maxParticipants: 600,
    duration: "4 hours",
    repetition: "N/A",
    ticket: {
      name: "VIP Pass",
      price: 50,
      currency: "USD",
      additionalInstructions: "Dress to impress!",
    },
    ticketsOnSale: 0,
  },
  {
    id: 8,
    topic: "Education",
    name: "Educational Seminar",
    image: "https://picsum.photos/1000?seed=29",
    date: "2023-09-28",
    location: "Education Center",
    time: "14:00",
    status: "Registration Open",
    price: "Free",
    organizer: {
      name: "Knowledge Hub",
      email: "info@knowledgehub.com",
      phone: "+1-999-888-7777",
      image: "https://picsum.photos/1000?seed=30",
    },
    participants: [{
        name: "Sophia Johnson",
        email: "sophia@example.com",
        phone: "+1-555-666-7777",
        image: "https://picsum.photos/1000?seed=31",
      },
      {
        name: "Daniel Smith",
        email: "daniel@example.com",
        phone: "+1-777-888-9999",
        image: "https://picsum.photos/1000?seed=32",
      },
    ],
    description: "Expand your horizons with our educational seminar!",
    videoUrl: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4",
    indoor: true,
    maxParticipants: 200,
    duration: "3 hours",
    repetition: "N/A",
    ticket: {
      name: "Free Entry",
      price: 0,
      currency: "USD",
      additionalInstructions: "Limited seats available. Register now!",
    },
    ticketsOnSale: 50,
  },
  {
    id: 9,
    topic: "Health",
    name: "Health and Wellness Expo",
    image: "https://picsum.photos/1000?seed=33",
    date: "2023-11-05",
    location: "Wellness Center",
    time: "11:00",
    status: "Registration Closed",
    price: "Free",
    organizer: {
      name: "Wellness Life",
      email: "info@wellnesslife.com",
      phone: "+1-888-777-6666",
      image: "https://picsum.photos/1000?seed=34",
    },
    participants: [{
        name: "Olivia Davis",
        email: "olivia@example.com",
        phone: "+1-555-666-8888",
        image: "https://picsum.photos/1000?seed=35",
      },
      {
        name: "James Wilson",
        email: "james@example.com",
        phone: "+1-777-888-6666",
        image: "https://picsum.photos/1000?seed=36",
      },
    ],
    description: "Explore the world of health and wellness at our expo!",
    videoUrl: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/SubaruOutbackOnStreetAndDirt.mp4",
    indoor: true,
    maxParticipants: 300,
    duration: "5 hours",
    repetition: "N/A",
    ticket: {
      name: "Wellness Pass",
      price: 0,
      currency: "USD",
      additionalInstructions: "Visit our booths for free health check-ups.",
    },
    ticketsOnSale: 0,
  },
  {
    id: 10,
    topic: "Business",
    name: "Business Conference",
    image: "https://picsum.photos/1000?seed=37",
    date: "2023-12-01",
    location: "Business Center",
    time: "09:30",
    status: "Rescheduled",
    price: "$50",
    organizer: {
      name: "Business Connect",
      email: "info@businessconnect.com",
      phone: "+1-666-777-8888",
      image: "https://picsum.photos/1000?seed=38",
    },
    participants: [{
        name: "Andrew Johnson",
        email: "andrew@example.com",
        phone: "+1-555-666-7777",
        image: "https://picsum.photos/1000?seed=39",
      },
      {
        name: "Emma Smith",
        email: "emma@example.com",
        phone: "+1-777-888-9999",
        image: "https://picsum.photos/1000?seed=40",
      },
    ],
    description: "Network and grow your business at our conference!",
    videoUrl: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4",
    indoor: true,
    maxParticipants: 400,
    duration: "7 hours",
    repetition: "Monthly",
    ticket: {
      name: "Business Pass",
      price: 50,
      currency: "USD",
      additionalInstructions: "Bring your business cards for networking opportunities.",
    },
    ticketsOnSale: 200,
  },
];

// event show list
export const showEvents = [{
    value: 10,
    label: "10",
  },
  {
    value: 20,
    label: "20",
  },
  {
    value: 30,
    label: "30",
  },
  {
    value: 40,
    label: "40",
  },
  {
    value: 50,
    label: "50",
  },
  {
    value: 60,
    label: "60",
  },
];

// organizers list
export const organizers = [{
    id: "1",
    name: "Hamza",
    package: "free",
    dob: "2002-02-02",
    streetaddress: "block 5",
    city: "Karachi",
    status: "cancel",
    gender: "male",
    stateprovince: "Sindh",
    postalcode: "75300",
    image: "https://picsum.photos/200?seed=1",
    country: "Pakistan",
    email: "hamza@gmail.com",
    phonenumber: "03172271459",
    identification: "123456789456",
    link1: "Link 1 of Hamza",
    link2: "Link 2 of Hamza",
    link3: "Link 3 of Hamza",
    link4: "Link 4 of Hamza",
  },
  {
    id: "2",
    name: "Ali",
    package: "premium",
    dob: "1995-05-15",
    streetaddress: "block 10",
    city: "Lahore",
    status: "verified",
    gender: "male",
    stateprovince: "Punjab",
    postalcode: "54000",
    image: "https://picsum.photos/200?seed=2",
    country: "Pakistan",
    email: "ali@gmail.com",
    phonenumber: "03361234567",
    identification: "9876543210",
    link1: "Link 1 of Ali",
    link2: "Link 2 of Ali",
    link3: "Link 3 of Ali",
    link4: "Link 4 of Ali",
  },
  {
    id: "3",
    name: "hamza",
    package: "free",
    dob: "1990-12-20",
    streetaddress: "block 3A",
    city: "Islamabad",
    status: "pending",
    gender: "female",
    stateprovince: "Islamabad Capital Territory",
    postalcode: "44000",
    image: "https://picsum.photos/200?seed=3",
    country: "Pakistan",
    email: "sara@gmail.com",
    phonenumber: "03213334455",
    identification: "1122334455",
    link1: "Link 1 of Sara",
    link2: "Link 2 of Sara",
    link3: "Link 3 of Sara",
    link4: "Link 4 of Sara",
  },
  {
    id: "4",
    name: "John",
    package: "premium",
    dob: "1988-08-08",
    streetaddress: "123 Main St",
    city: "New York",
    status: "verified",
    gender: "male",
    stateprovince: "New York",
    postalcode: "10001",
    image: "https://picsum.photos/200?seed=4",
    country: "USA",
    email: "john@gmail.com",
    phonenumber: "2125551234",
    identification: "9876543210",
    link1: "Link 1 of John",
    link2: "Link 2 of John",
    link3: "Link 3 of John",
    link4: "Link 4 of John",
  },
];

// organizer Reviews list
export const reviews = [{
    id: "1",
    image: "https://picsum.photos/200?seed=1",
    name: "Organizer 1",
    review: 4.5,
    text: "A great experience working with this organizer. They were highly professional and attentive to our needs. The event they organized exceeded our expectations, and we couldn't be happier. We would definitely recommend their services to others.",
    date: "2023-08-29",
    likes: 12,
    dislikes: 3,
    status: "published",
    type: "organizer",
  },
  {
    id: "2",
    image: "https://picsum.photos/200?seed=2",
    name: "Event 1",
    review: 4.0,
    text: "Attended an event organized by this team, and it was a memorable experience. The arrangements were top-notch, and everything went smoothly. Looking forward to attending more of their events!",
    date: "2023-08-30",
    likes: 10,
    dislikes: 2,
    status: "published",
    type: "event",
  },
  {
    id: "3",
    image: "https://picsum.photos/200?seed=3",
    name: "Organizer 2",
    review: 3.8,
    text: "Decent service provided by this organizer. There were a few hiccups during the event, but overall, it was a satisfactory experience. They could improve on their communication, though.",
    date: "2023-08-31",
    likes: 8,
    dislikes: 2,
    status: "published",
    type: "organizer",
  },
  {
    id: "4",
    image: "https://picsum.photos/200?seed=4",
    name: "Event 2",
    review: 4.2,
    text: "Attended their event, and it was enjoyable. The organizer was responsive and handled the event well. There were a few minor issues, but nothing too concerning. Would consider attending their events again.",
    date: "2023-09-01",
    likes: 9,
    dislikes: 1,
    status: "published",
    type: "event",
  },
  {
    id: "5",
    image: "https://picsum.photos/200?seed=5",
    name: "Organizer 3",
    review: 4.2,
    text: "Good service overall. The organizer was responsive and handled our event well. There were a few minor issues, but nothing too concerning. Would consider using their services again.",
    date: "2023-09-02",
    likes: 10,
    dislikes: 1,
    status: "published",
    type: "organizer",
  },
  {
    id: "6",
    image: "https://picsum.photos/200?seed=6",
    name: "Event 3",
    review: 4.7,
    text: "Attended their event and had a fantastic time. The event was well-organized, and the atmosphere was great. Highly recommended for those looking for enjoyable events.",
    date: "2023-09-03",
    likes: 15,
    dislikes: 0,
    status: "unpublished",
    type: "event",
  },
];

// pages list
export const pages = [
  {
      id: "1",
      title: "Coming soon",
      url: "/coming-soon",
      content: "Page under construction. Stay tuned!",
      meta: {
        title: "Coming Soon - Website Name",
        description: "Explore the upcoming changes and updates on our website.",
      },
      status: "published",
      template: "default",
      publish: "2023-09-01",
      visibility: "visible",
      category: "technology", // Added category
      faq: [{
        question: "What's coming soon on this page?",
        answer: "We have exciting updates and content planned for this page. Stay tuned for more information!",
      }, ],
    },
    {
      id: "2",
      title: "Career",
      url: "/career",
      content: "Explore career opportunities with us.",
      meta: {
        title: "Explore Career Opportunities - Website Name",
        description: "Find out about the latest job openings and career prospects with our company.",
      },
      status: "draft",
      template: "blog-sidebar",
      publish: "-",
      visibility: "visible",
      category: "food", // Added category
      faq: [{
          question: "What job positions are currently available?",
          answer: "We have a variety of job positions open. Please visit our careers page for the latest job listings.",
        },
        {
          question: "How can I apply for a job?",
          answer: "You can apply for a job by filling out the application form on our careers page and submitting your resume.",
        },
      ],
    },
    {
      id: "3",
      title: "Affiliate",
      url: "/affiliate",
      content: "Join our affiliate program and earn commissions.",
      meta: {
        title: "Join Our Affiliate Program - Website Name",
        description: "Become an affiliate and start earning commissions by promoting our products.",
      },
      status: "published",
      template: "full-width",
      publish: "2023-08-15",
      visibility: "visible",
      category: "health", // Added category
      faq: [],
    },
    {
      id: "4",
      title: "Cookie Policy",
      url: "/cookie-policy",
      content: "Learn about our cookie policy and usage.",
      meta: {
        title: "Learn About Our Cookie Policy - Website Name",
        description: "Understand how we use cookies on our website and how it affects your browsing experience.",
      },
      status: "published",
      template: "homepage",
      publish: "2023-07-02",
      visibility: "visible",
      category: "sports", // Added category
      faq: [],
    },
    {
      id: "5",
      title: "Contact",
      url: "/contact",
      content: "Get in touch with us using the contact form.",
      meta: {
        title: "Contact Us - Website Name",
        description: "Reach out to us for any inquiries or feedback using our contact form.",
      },
      status: "published",
      template: "coming-soon",
      publish: "2023-07-15",
      visibility: "visible",
      category: "travel", // Added category
      faq: [],
    },
    {
      id: "6",
      title: "FAQs",
      url: "/faqs",
      content: "Frequently Asked Questions - Find answers to common queries.",
      meta: {
        title: "Frequently Asked Questions - Website Name",
        description: "Discover answers to commonly asked questions on our website.",
      },
      status: "published",
      template: "default",
      publish: "2023-08-01",
      visibility: "visible",
      category: "technology", // Added category
      faq: [{
          question: "How can I contact customer support?",
          answer: "You can reach our customer support team by visiting the 'Contact Us' page and filling out the contact form.",
        },
        {
          question: "What is your return policy?",
          answer: "Our return policy allows returns within 30 days of purchase. Please refer to our 'Refund Policy' page for more details.",
        },
      ],
    },
    {
      id: "7",
      title: "Blog — Blog Page",
      url: "/blog",
      content: "Explore our blog for interesting articles and updates.",
      meta: {
        title: "Explore Our Blog - Website Name",
        description: "Read insightful articles and stay updated with our blog.",
      },
      status: "published",
      template: "blog-sidebar",
      publish: "2023-08-10",
      visibility: "visible",
      category: "food", // Added category
      faq: [],
    },
    {
      id: "8",
      title: "Refund Policy",
      url: "/refund-policy",
      content: "Learn about our refund policy and procedures.",
      meta: {
        title: "Learn About Our Refund Policy - Website Name",
        description: "Understand our refund policy and the procedures to request a refund.",
      },
      status: "published",
      template: "refund-policy",
      publish: "2023-08-20",
      visibility: "visible",
      category: "health", // Added category
      faq: [],
    },
    {
      id: "9",
      title: "Terms & Conditions",
      url: "/terms-and-conditions",
      content: "Read our terms and conditions of use.",
      meta: {
        title: "Read Our Terms & Conditions - Website Name",
        description: "Review our terms and conditions for using our website.",
      },
      status: "published",
      template: "terms-and-conditions",
      publish: "2023-09-01",
      visibility: "visible",
      category: "sports", // Added category
      faq: [],
    },
    {
      id: "10",
      title: "Terms Of Use",
      url: "/terms-of-use",
      content: "Read our terms of use for this website.",
      meta: {
        title: "Read Our Terms Of Use - Website Name",
        description: "Read our terms of use for this website.",
      },
      status: "published",
      template: "terms-of-use",
      publish: "2023-09-15",
      visibility: "visible",
      category: "technology", // Added category
      faq: [],
    },
];

// Transactions list
export const transactions = [
  {
    id: "1",
    chargeId: "123456",
    payerName: "John Doe",
    amount: "$50.00",
    paymentChannel: "Credit Card",
    payerID: "123",
    status: "Completed",
    createdAt: "2023-05-10 09:30 AM",
  },
  {
    id: "2",
    chargeId: "789101112",
    payerName: "Alice Smith",
    amount: "$75.50",
    paymentChannel: "PayPal",
    payerID: "456",
    status: "Pending",
    createdAt: "2023-05-11 02:45 PM",
  },
  {
    id: "3",
    chargeId: "1314151617",
    payerName: "Bob Johnson",
    amount: "$100.00",
    paymentChannel: "Credit Card",
    payerID: "789",
    status: "Completed",
    createdAt: "2023-05-12 11:15 AM",
  },
  {
    id: "4",
    chargeId: "1819202122",
    payerName: "Eve Brown",
    amount: "$25.25",
    paymentChannel: "Bitcoin",
    payerID: "101112",
    status: "Failed",
    createdAt: "2023-05-13 08:20 AM",
  },
  {
    id: "5",
    chargeId: "2324252627",
    payerName: "Charlie Lee",
    amount: "$60.75",
    paymentChannel: "Credit Card",
    payerID: "131415",
    status: "Completed",
    createdAt: "2023-05-14 04:10 PM",
  },
];

// payment methods
export const paymentMethods = [{
    id: "1",
    name: "Stripe",
    image: "https://martfury.botble.com/vendor/core/plugins/stripe/images/stripe.svg",
    description: "Customers can buy products and pay directly using Visa, Credit card via Stripe",
    link: "https://stripe.com/",
    stepsToUse: [
      "Register with Stripe",
      "After registration at Stripe, you will have Public, Secret keys",
      "Enter Public, Secret keys into the box on the right-hand",
    ],
    publicKey: "pk_test_1234567890",
    privateKey: "sk_test_abcdefghijklmnopqrstuvwxyz",
  },
  {
    id: "2",
    name: "PayPal",
    image: "https://martfury.botble.com/vendor/core/plugins/paypal/images/paypal.svg",
    description: "PayPal is a widely used online payment platform that allows customers to pay securely using their PayPal account or credit card.",
    link: "https://www.paypal.com/",
    stepsToUse: [
      "Create a PayPal Business account",
      "Obtain your PayPal API credentials",
      "Integrate PayPal SDK into your website or application",
    ],
    publicKey: "",
    privateKey: "",
  },
  {
    id: "3",
    name: "Razorpay",
    image: "https://martfury.botble.com/vendor/core/plugins/razorpay/images/razorpay.svg",
    description: "Razorpay is a payment gateway that enables businesses to accept online payments through various methods.",
    link: "https://razorpay.com/",
    stepsToUse: [
      "Sign up with Razorpay",
      "Get your Razorpay API keys",
      "Integrate Razorpay into your website or application",
    ],
    publicKey: "pk_test_aabbccddeeff",
    privateKey: "sk_test_1234567890",
  },
  {
    id: "4",
    name: "Paystack",
    image: "https://martfury.botble.com/vendor/core/plugins/paystack/images/paystack.png",
    description: "Paystack is a payments processing company that allows businesses in Africa to accept payments via multiple channels.",
    link: "https://paystack.com/",
    stepsToUse: [
      "Create a Paystack account",
      "Obtain your Paystack API keys",
      "Integrate Paystack into your website or application",
    ],
    publicKey: "pk_test_abcdefg12345",
    privateKey: "sk_test_xyz78910",
  },
  {
    id: "5",
    name: "SslCommerz",
    image: "https://martfury.botble.com/vendor/core/plugins/sslcommerz/images/sslcommerz.png",
    description: "SslCommerz is a payment gateway that provides secure and reliable online payment solutions.",
    link: "https://sslcommerz.com/",
    stepsToUse: [
      "Register with SslCommerz",
      "Obtain your SslCommerz API credentials",
      "Integrate SslCommerz into your website or application",
    ],
    publicKey: "pk_test_demo_key_123",
    privateKey: "sk_test_demo_secret_456",
  },
];

//  categories
export const categories = [{
    id: 1,
    name: "Sports",
    slug: "sports",
    description: "All sports-related events",
    image: "https://picsum.photos/1000?seed=1",
    status: "Active",
    created: "2023-09-01 12:00:00",
    updated: "2023-09-01 12:00:00",
  },
  {
    id: 11,
    parentCategoryId: 1, // Parent category's ID
    name: "Football",
    slug: "football",
    description: "Football events",
    image: "https://picsum.photos/1000?seed=11",
    status: "Inactive",
    created: "2023-09-01 12:00:00",
    updated: "2023-09-01 12:00:00",
  },
  {
    id: 12,
    parentCategoryId: 1, // Parent category's ID
    name: "Basketball",
    slug: "basketball",
    description: "Basketball events",
    image: "https://picsum.photos/1000?seed=12",
    status: "Active",
    created: "2023-09-01 12:00:00",
    updated: "2023-09-01 12:00:00",
  },
  {
    id: 2,
    name: "Fashion",
    slug: "fashion",
    description: "All fashion-related events",
    image: "https://picsum.photos/1000?seed=2",
    status: "Active",
    created: "2023-09-01 12:00:00",
    updated: "2023-09-01 12:00:00",
  },
  {
    id: 13,
    parentCategoryId: 2, // Parent category's ID
    name: "Shoes",
    slug: "shoes",
    description: "Shoe events",
    image: "https://picsum.photos/1000?seed=13",
    status: "Active",
    created: "2023-09-01 12:00:00",
    updated: "2023-09-01 12:00:00",
  },
  {
    id: 14,
    parentCategoryId: 2, // Parent category's ID
    name: "Shirts",
    slug: "shirts",
    description: "Shirt events",
    image: "https://picsum.photos/1000?seed=14",
    status: "Active",
    created: "2023-09-01 12:00:00",
    updated: "2023-09-01 12:00:00",
  },
  // Add 10 more categories below
  {
    id: 3,
    name: "Music",
    slug: "music",
    description: "All music-related events",
    image: "https://picsum.photos/1000?seed=3",
    status: "Active",
    created: "2023-09-01 12:00:00",
    updated: "2023-09-01 12:00:00",
  },
  {
    id: 15,
    parentCategoryId: 3, // Parent category's ID
    name: "Concerts",
    slug: "concerts",
    description: "Concert events",
    image: "https://picsum.photos/1000?seed=15",
    status: "Active",
    created: "2023-09-01 12:00:00",
    updated: "2023-09-01 12:00:00",
  },
  {
    id: 16,
    parentCategoryId: 3, // Parent category's ID
    name: "Festivals",
    slug: "festivals",
    description: "Festival events",
    image: "https://picsum.photos/1000?seed=16",
    status: "Active",
    created: "2023-09-01 12:00:00",
    updated: "2023-09-01 12:00:00",
  },
  {
    id: 4,
    name: "Food",
    slug: "food",
    description: "All food-related events",
    image: "https://picsum.photos/1000?seed=4",
    status: "Active",
    created: "2023-09-01 12:00:00",
    updated: "2023-09-01 12:00:00",
  },
  {
    id: 17,
    parentCategoryId: 4, // Parent category's ID
    name: "Restaurants",
    slug: "restaurants",
    description: "Restaurant events",
    image: "https://picsum.photos/1000?seed=17",
    status: "Active",
    created: "2023-09-01 12:00:00",
    updated: "2023-09-01 12:00:00",
  },
  {
    id: 18,
    parentCategoryId: 4, // Parent category's ID
    name: "Cooking Classes",
    slug: "cooking-classes",
    description: "Cooking class events",
    image: "https://picsum.photos/1000?seed=18",
    status: "Active",
    created: "2023-09-01 12:00:00",
    updated: "2023-09-01 12:00:00",
  },
  {
    id: 5,
    name: "Technology",
    slug: "technology",
    description: "All technology-related events",
    image: "https://picsum.photos/1000?seed=5",
    status: "Active",
    created: "2023-09-01 12:00:00",
    updated: "2023-09-01 12:00:00",
  },
  {
    id: 19,
    parentCategoryId: 5, // Parent category's ID
    name: "Coding Bootcamps",
    slug: "coding-bootcamps",
    description: "Coding bootcamp events",
    image: "https://picsum.photos/1000?seed=19",
    status: "Active",
    created: "2023-09-01 12:00:00",
    updated: "2023-09-01 12:00:00",
  },
];

// ticket types
export const ticketTypes = [
  { id: "vip", name: "VIP Ticket" },
  { id: "general", name: "General Admission Ticket" },
  { id: "student", name: "Student Ticket" },
  { id: "senior", name: "Senior Citizen Ticket" },
  { id: "child", name: "Child Ticket" },
  { id: "family", name: "Family Ticket" },
  { id: "group", name: "Group Ticket" },
  { id: "earlybird", name: "Early Bird Ticket" },
  { id: "premium", name: "Premium Ticket" },
  // Add more ticket types as needed
];

//  users
export const users = [
  {
    id: 1,
    name: "John",
    email: "john@example.com",
    phone: "123-456-7890",
    image: "https://picsum.photos/1000?seed=1",
    account_creation_date: "2020-03-10",
    birthdate: "1990-05-15",
    bio: "This is John's bio. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    agreeToTerms: true,
    address: {
      street: "123 Main St",
      country: "United States",
      city: "New York",
      state: "NY",
      zip_code: "10001",
    },
    payment_info: ["id_89457jcje63","id_101112klmno"],
    user_roles: ["admin", "editor"],
    activity_history: [
      {
        date: "2023-09-05",
        action: "Logged in",
      },
      {
        date: "2023-09-06",
        action: "Updated profile",
      },
    ],
    subscriptions: [
      {
        service: "Newsletter",
        subscribed: true,
      },
      {
        service: "Premium Content",
        subscribed: false,
      },
    ],
    gender: "male",
  },
  {
    id: 2,
    name: "Alice",
    email: "alice@example.com",
    phone: "987-654-3210",
    image: "https://picsum.photos/1000?seed=2",
    account_creation_date: "2021-02-15",
    birthdate: "1985-08-20",
    bio: "This is Alice's bio. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    agreeToTerms: true,
    address: {
      street: "456 Elm St",
      country: "United States",
      city: "Los Angeles",
      state: "CA",
      zip_code: "90001",
    },
    payment_info: ["id_12345abcde"],
    user_roles: ["editor"],
    activity_history: [
      {
        date: "2023-09-07",
        action: "Logged in",
      },
      {
        date: "2023-09-08",
        action: "Uploaded a new article",
      },
    ],
    subscriptions: [
      {
        service: "Newsletter",
        subscribed: true,
      },
      {
        service: "Premium Content",
        subscribed: true,
      },
    ],
    gender: "Female",
  },
  {
    id: 3,
    name: "Bob",
    email: "bob@example.com",
    phone: "555-123-4567",
    image: "https://picsum.photos/1000?seed=3",
    account_creation_date: "2019-11-20",
    birthdate: "1978-12-10",
    bio: "This is Bob's bio. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    agreeToTerms: true,
    address: {
      street: "789 Oak St",
      country: "United States",
      city: "Chicago",
      state: "IL",
      zip_code: "60601",
    },
    payment_info: ["id_78910fghij"],
    user_roles: ["user"],
    activity_history: [
      {
        date: "2023-09-09",
        action: "Logged in",
      },
      {
        date: "2023-09-10",
        action: "Viewed user dashboard",
      },
    ],
    subscriptions: [
      {
        service: "Newsletter",
        subscribed: false,
      },
    ],
    gender: "male",
  },
  {
    id: 4,
    name: "Emily",
    email: "emily@example.com",
    phone: "555-555-5555",
    image: "https://picsum.photos/1000?seed=4",
    account_creation_date: "2022-04-05",
    birthdate: "1995-11-25",
    bio: "This is Emily's bio. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    agreeToTerms: true,
    address: {
      street: "567 Pine St",
      country: "United States",
      city: "San Francisco",
      state: "CA",
      zip_code: "94101",
    },
    payment_info: ["id_101112klmno"],
    user_roles: ["user"],
    activity_history: [
      {
        date: "2023-09-11",
        action: "Logged in",
      },
      {
        date: "2023-09-11",
        action: "Updated profile picture",
      },
    ],
    subscriptions: [
      {
        service: "Newsletter",
        subscribed: true,
      },
    ],
    gender: "Female",
  },
];

// payment method
export const userPaymentMethods = [
  {
    methodType: "Master Card",
    methodImage: "https://img.icons8.com/fluency/100/mastercard.png",
    methodExpire: "Expires Dec 2024",
    name: "Max Smith",
    number: "**** 7770",
    expires: "08/2021",
    type: "American Express Credit Card",
    issuer: "USABANK",
    id: "id_89457jcje63",
    billingAddress: "US",
    phone: "No phone provided",
    email: "max@kt.com",
    origin: "United States of America",
    cvcCheck: "Failed",
  },
  {
    methodType: "Visa",
    methodImage: "https://img.icons8.com/fluency/100/visa.png",
    methodExpire: "Expires Jan 2023",
    name: "Alice Johnson",
    number: "**** 1234",
    expires: "12/2022",
    type: "Visa Debit Card",
    issuer: "Bank of America",
    id: "id_12345abcde",
    billingAddress: "CA",
    phone: "123-456-7890",
    email: "alice@example.com",
    origin: "United States of America",
    cvcCheck: "Passed",
  },
  {
    methodType: "Discover",
    methodImage: "https://img.icons8.com/fluency/100/discover.png", // Replace with actual image URL
    methodExpire: "Expires Feb 2023",
    name: "Sarah Davis",
    number: "**** 9876",
    expires: "02/2023",
    type: "Discover Credit Card",
    issuer: "Discover Bank",
    id: "id_78910fghij",
    billingAddress: "TX",
    phone: "555-555-5555",
    email: "sarah@example.com",
    origin: "United States of America",
    cvcCheck: "Passed",
  },
  {
    methodType: "Amex",
    methodImage: "https://img.icons8.com/fluency/100/amex.png", // Replace with actual image URL
    methodExpire: "Expires Jul 2025",
    name: "Michael Brown",
    number: "**** 5678",
    expires: "07/2025",
    type: "American Express Credit Card",
    issuer: "Amex Bank",
    id: "id_101112klmno",
    billingAddress: "NY",
    phone: "999-999-9999",
    email: "michael@example.com",
    origin: "United States of America",
    cvcCheck: "Passed",
  },
];
